module.exports = __webpack_public_path__ + "img/generic_phone_teaser.ee29832a.png";